import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Facebook, Phone, Globe, Mail } from 'lucide-react';
import BrandLogo from './BrandLogo';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    platform: [
      { name: 'Ledger Service', path: '/ledger' },
      { name: 'Staking', path: '/staking' },
      { name: 'Trading', path: '/trading' },
    ],
    resources: [
      { name: 'Help Center', path: '#' },
      { name: 'Blog', path: '#' },
    ],
    company: [
      { name: 'About Us', path: '/about' },
      { name: 'Careers', path: '#' },
      { name: 'Contact', path: '/contact' },
    ],
    legal: [
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Terms of Service', path: '/terms-of-service' },
      { name: 'Cookie Policy', path: '/cookie-policy' },
    ],
  };

  const socialLinks = [
    { icon: Twitter, href: 'https://twitter.com/FTMX', label: 'Twitter' },
    { icon: Facebook, href: 'https://facebook.com/FTMX', label: 'Facebook' },
    { icon: Phone, href: 'https://wa.me/16064608993', label: 'WhatsApp' },
    { icon: Mail, href: 'mailto:support@ftmx.com', label: 'Email' },
  ];

  const supportedChains = [
    'Ethereum', 'Bitcoin', 'BNB Chain', 'Polygon', 'Solana', 
    'Avalanche', 'Arbitrum', 'Optimism', '+42 more'
  ];

  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid">
            {/* Brand Column */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <BrandLogo height={32} />
              </Link>
              <p className="footer-description">
                Fair launch. Community driven. Built for the people — take back control from the matrix.
              </p>
              <div className="footer-socials">
                {socialLinks.map((social, index) => (
                  <a 
                    key={index} 
                    href={social.href} 
                    className="social-link"
                    aria-label={social.label}
                  >
                    <social.icon size={20} />
                  </a>
                ))}
              </div>
            </div>

            {/* Links Columns */}
            <div className="footer-links-column">
              <h4>Platform</h4>
              <ul>
                {footerLinks.platform.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footer-links-column">
              <h4>Company</h4>
              <ul>
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <Link to={link.path}>{link.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <h4>Stay Updated</h4>
              <p>Get the latest news and updates from FTMX.</p>
              <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                <div className="input-group">
                  <Mail size={18} className="input-icon" />
                  <input 
                    type="email" 
                    placeholder="Enter your email" 
                    required 
                  />
                </div>
                <button type="submit" className="btn btn-primary">
                  Subscribe
                </button>
              </form>
            </div>
          </div>

          {/* Supported Chains */}
          <div className="footer-chains">
            <div className="chains-label">
              <Globe size={16} />
              <span>Supported Networks</span>
            </div>
            <div className="chains-list">
              {supportedChains.map((chain, index) => (
                <span key={index} className="chain-tag">{chain}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-bottom-inner">
            <p>© {currentYear} FTMX. All rights reserved.</p>
            <div className="footer-legal">
              {footerLinks.legal.map((link, index) => (
                <Link key={index} to={link.path}>{link.name}</Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
